import { useContext } from 'react';
import SystemsHealthContext, { SystemsHealthCtxType } from './systems-health-context';

export default function useSystemsHealth(): SystemsHealthCtxType {
  return useContext(SystemsHealthContext);
}
